import { absoluteUrl, LOGO_URL } from './site';

function inject(data: object | object[] | null) {
  const id = 'readdy-seo-jsonld';
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  if (!data) return;

  const el = document.createElement('script');
  el.type = 'application/ld+json';
  el.id = id;
  el.textContent = JSON.stringify(data);
  document.head.appendChild(el);
}

export function setWebsiteJsonLd(description: string) {
  inject([
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'CSSBuy Spreadsheet',
      url: absoluteUrl('/'),
      description,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'CSSBuy Spreadsheet',
      url: absoluteUrl('/'),
      logo: LOGO_URL,
    },
  ]);
}

export function setArticleJsonLd(opts: {
  title: string;
  description: string;
  image: string;
  url: string;
}) {
  inject({
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: opts.title,
    description: opts.description,
    image: [opts.image],
    mainEntityOfPage: { '@type': 'WebPage', '@id': opts.url },
    author: { '@type': 'Organization', name: 'CSSBuy Spreadsheet' },
    publisher: {
      '@type': 'Organization',
      name: 'CSSBuy Spreadsheet',
      logo: { '@type': 'ImageObject', url: LOGO_URL },
    },
    datePublished: '2026-08-26',
    dateModified: '2026-08-26',
  });
}

export function clearJsonLd() {
  inject(null);
}